module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-196.c6fa7a91.svg";